export default ($parse, CartPicker) => ({
  scope: false,
  link(scope, element, attr) {
    let picker = new CartPicker();
    let fieldName = attr.ngModel || attr.cartPicker || "cartPicker";

    attr.onSelected &&
      picker.selected.on((cart) =>
        $parse(attr.onSelected)(scope, { $selected: cart })
      );
    fieldName && $parse(fieldName).assign(scope, picker);

    var $targets = attr.clickSelector
      ? element.find(attr.clickSelector)
      : element;
    $targets.on("click", (e) => picker.open(scope.$eval(attr.current)));
  },
});
